/**
 * @fileoverview Largura do painel "Dados do contato". A normal é fixa; a
 * expandida (só no computador) cresce até 600 px sem deixar a conversa ao lado
 * com menos de 420 px e nunca fica menor que a normal. O painel e a margem da
 * conversa leem a mesma variável CSS, definida no contêiner do ticket, para as
 * duas larguras sempre baterem. Arquivo à parte para o Ticket não carregar o
 * painel (que é importado sob demanda) só por causa das constantes.
 */

export const CONTACT_DRAWER_WIDTH = 360;
export const CONTACT_DRAWER_MIN_CHAT = 420;
export const CONTACT_DRAWER_MAX_WIDTH = 600;
export const CONTACT_DRAWER_EXPANDED_WIDTH = `clamp(${CONTACT_DRAWER_WIDTH}px, calc(100% - ${CONTACT_DRAWER_MIN_CHAT}px), ${CONTACT_DRAWER_MAX_WIDTH}px)`;
export const CONTACT_DRAWER_WIDTH_VAR = "--contact-drawer-width";
export const contactDrawerWidth = `var(${CONTACT_DRAWER_WIDTH_VAR}, ${CONTACT_DRAWER_WIDTH}px)`;
/** Só oferece expandir quando o painel ganharia pelo menos isto. */
export const CONTACT_DRAWER_MIN_GAIN = 80;
/** Preferência deste navegador: o painel volta expandido se ficou assim. */
export const CONTACT_DRAWER_EXPANDED_KEY = "contactDrawerExpanded";

/** Cabe expandir num contêiner desta largura (px)? */
export const canExpandContactDrawer = (containerWidth) =>
  containerWidth - CONTACT_DRAWER_MIN_CHAT >= CONTACT_DRAWER_WIDTH + CONTACT_DRAWER_MIN_GAIN;
